import React, { useEffect, useState } from "react";
import useCalendarSale from "../hooks/useCalendarSale";
import "./style.scss";

import { BsCalendarDate } from "react-icons/bs";
import format from "date-fns/format";
import CalendarDayPicker from "../DayPicker";
import { useMediaQuery } from "@mui/material";
import ModalComponent from "../../../../features/ModalComponent";
import CalendarOneExercise from "./CalendarOneExercise";
import CalendarMultiExercise from "./CalendarMultiExercise";
import useFacility from "../../../../utils/hooks/useFacility";
import { useTranslation } from "react-i18next";
import useSchedule from "../../ScheduleExercise/hooks/useSchedule";
import { State } from "../../../store";
import { useSelector } from "react-redux";

interface IProps {
  exerciseName: string;
  zone: number;
}

const CalendarModal: React.FC<IProps> = ({ exerciseName, zone }: IProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [openHours, setOpenHours] = useState(false);
  const [showLastStep, setShowLastStep] = useState(false);
  const [clicked, wasClicked] = useState(0);
  const facilityIds = useFacility();
  const alwaysShowHoursToChoose = useSelector((state: State) => state.config.configuration.alwaysShowHoursToChoose);




  const [timeToEntry, showTimeToEntry] = useState(true);
  const matches = useMediaQuery("(min-width: 1100px)");
 
  
  const {
    getHoursAvaiableByName,
    exercise,
    selectedDate,
    getDaysAvailableByName,
    listaDat,
    joinToExercise,
    alerts,
    firstAvailableDate,
  } = useCalendarSale();

  const refreshCapacityAfterAddTicket = () => {
    getHoursAvaiableByName(selectedDate, exerciseName);
  };

  const joinToExerciseByPass = (exerciseIds: string, assignType: boolean, passId: number) => {
    // num.toString(passId)
    const StringPassId = "0," + passId;
    // const numberExeciseIds = "0," + exerciseIds
    joinToExercise(Number(exerciseIds), assignType, StringPassId, () => refreshCapacityAfterAddTicket());
    // getAssignByTicket(passId, Number(exerciseIds))
  };

  const handleCloseModal = (boolean: boolean) => {
    setOpenHours(boolean);
    setOpen(boolean);
  };

  useEffect(() => {
    getDaysAvailableByName(exerciseName);

    if (exercise.length > 1) {
      showTimeToEntry(true);
    }
    if (exercise.length === 1) {
      if (facilityIds === "1220" || facilityIds === "350" || facilityIds === "1228") {
        showTimeToEntry(true);
      } else {
        showTimeToEntry(false);
      }
      if(alwaysShowHoursToChoose === true){
        showTimeToEntry(true)
      }else {
        showTimeToEntry(false);
      }
    }
  }, [exercise]);

  return (
    <React.Fragment>
      {matches ? (
        <React.Fragment>
          <div className="calendar-modal-steps flex-between ">
            <div className="step flex-center-center">
              <b>1</b>
              <span>{t("wybierz_date")}</span>
            </div>

            {exercise && (
              <React.Fragment>
                {exercise.length > 0 && timeToEntry === true && (
                  <React.Fragment>
                    <div className="step flex-center-center">
                      <b>2</b>
                      <span>{t("godzina_wejscia")}</span>
                    </div>
   <div className="step flex-center-center">
                      <b>3</b>
                      <span>{t("wybierz_rodzaj_i_ilosc_biletow")}</span>
                    </div>
                 
                  </React.Fragment>
                )}

                {exercise.length > 0 && timeToEntry === false && (
                  <div className="big-step flex-center-center">
                    <b>2</b>
                    <span>{t("wybierz_rodzaj_i_ilosc_biletow")}</span>
                  </div>
                )}
              </React.Fragment>
            )}
          </div>
          <div className="calendar-modal flex-between">
            <div className="box day-picker border shadow">
              <CalendarDayPicker
                getExercisesByDate={getHoursAvaiableByName}
                selectedDate={selectedDate}
                exerciseName={exerciseName}
                listaDat={listaDat}
                defaultDate={firstAvailableDate}
              />
            </div>

            {exercise && (
              <React.Fragment>
                {exercise.length > 0 && timeToEntry === false && (
                  <CalendarOneExercise
                    alertCalendar={alerts}
                    joinToExerciseByPass={joinToExerciseByPass}
                    exercise={exercise[0]}
                    refreshCapacityAfterAddTicket={refreshCapacityAfterAddTicket}
                  />
                )}
                {exercise.length > 0 && timeToEntry === true && (
                  <CalendarMultiExercise
                    alertCalendar={alerts}
                    joinToExerciseByPass={joinToExerciseByPass}
                    exercise={exercise}
                    refreshCapacityAfterAddTicket={refreshCapacityAfterAddTicket}
                  />
                )}
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div className="calendar-modal">
            <div className="calendar-modal-steps">
              <div className="step flex-start-center">
                <b>1</b>
                <span>{t("wybierz_date")}</span>
              </div>
            </div>

            <div className="box flex-between-center">
              <div className="flex-start-center">
                <BsCalendarDate className="box-icon" />
                <div className="box-text">
                  <span>{t("wybierz_dzien")}</span>
                  {clicked === 0 ? <span>{t("nie_wybrano")}</span> : <b>{format(selectedDate, "yyyy-MM-dd")}</b>}
                </div>
              </div>

              {clicked === 0 ? (
                <button
                  onClick={() => {
                    setOpen(!open);
                    wasClicked(1);
                  }}
                  className="button medium padding-small button-fill-main"
                >
                  {t("wybierz")}
                </button>
              ) : (
                <button
                  onClick={() => {
                    setOpen(!open);
                    wasClicked(1);
                  }}
                  className="button medium padding-small button-fill-background-main"
                >
                  {t("zmien")}
                </button>
              )}
            </div>

            {exercise.length > 0 && timeToEntry === false && (
              <CalendarOneExercise
                alertCalendar={alerts}
                joinToExerciseByPass={joinToExerciseByPass}
                exercise={exercise[0]}
                refreshCapacityAfterAddTicket={refreshCapacityAfterAddTicket}
              />
            )}
            {exercise.length > 0 && timeToEntry === true && (
              <CalendarMultiExercise
                alertCalendar={alerts}
                joinToExerciseByPass={joinToExerciseByPass}
                exercise={exercise}
                clicked={clicked}
                refreshCapacityAfterAddTicket={refreshCapacityAfterAddTicket}
              />
            )}
          </div>

          {open && (
            <ModalComponent
              footer={false}
              open={open}
              closeModal={() => setOpen(false)}
              title={t("wybierz_date")}
              onAccept={() => setOpen(false)}
            >
              <CalendarDayPicker
                getExercisesByDate={getHoursAvaiableByName}
                selectedDate={selectedDate}
                exerciseName={exerciseName}
                handleCloseModal={handleCloseModal}
                listaDat={listaDat}
              />
            </ModalComponent>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default CalendarModal;
